var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.795 21.4834L28.32 35.6934C28.3483 35.8607 28.3248 36.0327 28.2527 36.1863C28.1806 36.3399 28.0633 36.4679 27.9166 36.5531C27.7698 36.6382 27.6005 36.6766 27.4314 36.6629C27.2622 36.6493 27.1012 36.5843 26.97 36.4767L21.0033 31.9984C20.7153 31.7832 20.3654 31.6669 20.0058 31.6669C19.6463 31.6669 19.2964 31.7832 19.0083 31.9984L13.0317 36.4751C12.9005 36.5825 12.7398 36.6473 12.5708 36.661C12.4019 36.6746 12.2328 36.6364 12.0861 36.5515C11.9394 36.4666 11.8221 36.3389 11.7499 36.1856C11.6776 36.0323 11.6538 35.8606 11.6817 35.6934L14.205 21.4834",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 23.3335C25.5228 23.3335 30 18.8563 30 13.3335C30 7.81065 25.5228 3.3335 20 3.3335C14.4772 3.3335 10 7.81065 10 13.3335C10 18.8563 14.4772 23.3335 20 23.3335Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.079c73eb8b3aecc5006b53f1f71af7ca.svg";
export { ForwardRef as ReactComponent };